import React from 'react';

export const ExhibitorsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 3.33333C0 1.49238 1.49238 0 3.33333 0H16.6667C18.5076 0 20 1.49238 20 3.33333V16.6667C20 18.5076 18.5076 20 16.6667 20H3.33333C1.49238 20 0 18.5076 0 16.6667V3.33333Z"
        fill="#333333"
      />
      <path
        d="M16.0983 7.87083H14.2747V6.49985H12.4511V5H7.54854V6.46019H5.72496V8.05583H3.90137V12.1292H5.72496V13.5002H7.54854V15H12.4511V13.5398H14.2747V11.9442H16.0983V7.87083ZM14.9849 10.8309H13.1614V12.4265H11.3378V13.8867H8.65525V12.3868H6.83166V11.0159H5.00807V9.16583H6.83166V7.57021H8.65525V6.11H11.3378V7.60985H13.1614V8.98083H14.9849V10.8309Z"
        fill="white"
      />
    </svg>
  );
};
